import React from 'react'
import ReportsChart from '../components/ReportsChart'

export default function Reports() {
  return (
    <div>
      <ReportsChart/>
    </div>
  )
}
